require('./antenne-accessible.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class AntenneAccessibleComponent {
  constructor() {
    this.controller = AntenneAccessibleController;
    this.template = require('./antenne-accessible.html');
  }
}

// @ngInject
class AntenneAccessibleController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.ANTENNE_ACCESSIBLE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.antenneAccessible ? state.demande.data.antenneAccessible.asMutable({deep: true}) : this.data
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAntenneAccessible(this.data, true));
  }
  nextStep(source) {
    this.data.source = source;
    this.$ngRedux.dispatch(DemandeActions.updateAntenneAccessible(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/antenne-accessible/antenne-accessible.component.js